import React, { useEffect, useRef } from "react";
import { TextField } from "@mui/material";

/**
 * Título editable en cabecera: blur / Enter guarda; Esc revierte.
 * `entityKey` reinicia el valor confirmado al cambiar de ítem.
 */
export default function SkillAgentInlineTitle({
  entityKey,
  value,
  onChange,
  onCommit,
  placeholder,
  disabled = false,
  inputSx,
  sx,
}) {
  const committedRef = useRef(String(value || ""));

  useEffect(() => {
    committedRef.current = String(value || "");
  }, [entityKey]); // eslint-disable-line react-hooks/exhaustive-deps -- solo al cambiar de ítem

  const commit = () => {
    const next = String(value || "").trim();
    const prev = String(committedRef.current || "").trim();
    if (!next) {
      if (prev) onChange?.(prev);
      return;
    }
    if (next === prev) return;
    committedRef.current = next;
    onCommit?.(next);
  };

  return (
    <TextField
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
        if (e.key === "Escape") {
          e.preventDefault();
          onChange?.(committedRef.current);
          e.currentTarget.blur();
        }
      }}
      disabled={disabled}
      variant="standard"
      placeholder={placeholder}
      title={placeholder}
      InputProps={{ disableUnderline: true }}
      sx={{
        minWidth: 120,
        flex: "1 1 auto",
        maxWidth: { xs: "100%", md: 420 },
        ...sx,
        "& .MuiInputBase-input": {
          fontWeight: 800,
          fontSize: "1.25rem",
          lineHeight: 1.25,
          letterSpacing: "-0.01em",
          py: 0.15,
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...inputSx,
        },
      }}
    />
  );
}
